import { merge } from "lodash";

import type { Permission } from "~/types/auth.type";

import { ownerPermissions } from "./owner.constant";

export const installerPermissions: Permission = merge<Permission, Permission>(
  JSON.parse(JSON.stringify(ownerPermissions)) as Permission,
  {
    valve: {
      delete: true,
      gatewayId: { update: true },
      floor: { update: true },
      uid: { update: true },
      trigCur: { read: true },
      stateData: {
        dateBat: { read: true },
      },
    },
    multisensor: {
      delete: true,
      gatewayId: { update: true },
      uid: { update: true },
      floor: { update: true },
      stateData: {
        dateBat: { read: true },
      },
    },
    history: {
      valve: {
        // Runtime checks only use histoValve.read (see floors / valve-tooltip / maintenance).
        // TODO check later: restore per-point granularity if Permission.history.valve.histoValve is retargeted away from HistoryDto[]
        histoValve: {
          read: true,
          // hygrometry: { read: true },
          // pressure: { read: true },
          // gazRaw: { read: true },
          // soundCounter: { read: true },
          // rssi: { read: true },
          // lqi: { read: true },
          // bvoc: { read: true },
          // maxOpening: { read: true },
        },
        battery: {
          read: true,
        },
        meca: {
          read: true,
        },
        lastActivity: {
          read: true,
        },
      },
      gateway: {
        lastGatewayActivity: {
          read: true,
        },
      },
    },
    mesh: {
      create: true,
      update: true,
      delete: true,
      read: true,
    },
    gateway: {
      delete: true,
      floor: { update: true },
      brModRf: { read: true, update: true },
      isInternetGateway: { update: true },
      borderRouterStatus: { read: true },
      meshes: { read: true },
      uid: { update: true },
    },
    floor: {
      create: true,
      update: true,
      delete: true,
    },
    room: {
      update: true,
      warning: true,
      delete: true,
      floor: { update: true },
    },
    module: {
      create: true,
      update: true,
      delete: true,
      read: true,
      boilerroom: {
        update: true,
        variableData: {
          read: true,
          update: true,
        },
        floor: { update: true },
      },
      airHandlerUnit: {
        update: true,
        variableData: {
          read: true,
          update: true,
        },
        floor: { update: true },
      },
    },
    building: {
      delete: false,
    },
    alarm: {
      create: true,
      delete: true,
    },
  },
);
